// extracted by mini-css-extract-plugin
module.exports = {"outer":"modal-v2_outer__m5fx6","mobile-menu":"modal-v2_mobile-menu__twGba","alert":"modal-v2_alert__KqQyS","inner":"modal-v2_inner__YCNMa","medium":"modal-v2_medium__2X3wn"};